import React from "react";
import { Table } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import translate from "../../../../utils/Translator";
import style from "../Grid.module.scss";

const ProvisionsPaymentAccounts = ({ accounts }) => (
  <div className={style.grid}>
    <h6 className="my-3">{translate("Account")}s</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>{translate("Account")}</th>
          <th>Custodian</th>
          <th>Currency</th>
          <th>Volume</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody>
        {accounts.map((item) => (
          <tr key={item.PaymentAccountId}>
            <td>{item.PaymentAccountName}</td>
            <td>{item.PaymentAccountCustodianName}</td>
            <td>{item.PaymentAccountCurrencyISO}</td>
            <td className="text-right">
              <FormattedNumber value={item.PaymentAccountVolumen} dataTypeDecimalName="currency" />
            </td>
            <td className="text-right">
              <FormattedNumber value={item.PaymentAccountBalance} dataTypeDecimalName="currency" />
            </td>
          </tr>
        ))}
        {accounts.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No {translate("Account")}s
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

ProvisionsPaymentAccounts.propTypes = {
  accounts: PropTypes.array.isRequired,
};

export default ProvisionsPaymentAccounts;
